import { useState, useEffect } from "react";
import { AlertTriangle, AlertCircle } from "lucide-react";
import "./StockAlerts.scss";

const StockAlerts = ({ clinicaId, auth, sendRequest }) => {
  const [alerts, setAlerts] = useState({
    lowStock: [],
    expiringSoon: [],
    outOfStock: [],
    expired: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAlerts = async () => {
      try {
        setLoading(true);
        // A API real deve ser usada aqui
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/stocks/alerts/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        setAlerts({
          lowStock: responseData.alerts.lowStock || [],
          expiringSoon: responseData.alerts.expiringSoon || [],
          outOfStock: responseData.alerts.outOfStock || [],
          expired: responseData.alerts.expired || [],
        });
      } catch (err) {
        setError("Erro ao conectar com o servidor");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (clinicaId) {
      fetchAlerts();
    }
  }, [clinicaId, sendRequest, auth]);

  const totalAlerts =
    alerts.lowStock.length +
    alerts.expiringSoon.length +
    alerts.outOfStock.length +
    alerts.expired.length;

  if (loading)
    return <div className="stock-alerts-loading">Carregando alertas...</div>;
  if (error) return <div className="stock-alerts-error">{error}</div>;

  return (
    <div className="stock-alerts-container caixa">
      <div className="stock-alerts-header">
        <AlertTriangle className="icon alert-icon" />
        <h2>Alertas de Stock</h2>
        <span className="alert-badge">
          {totalAlerts} alerta{totalAlerts !== 1 ? "s" : ""} encontrado
          {totalAlerts !== 1 ? "s" : ""}
        </span>
        <div className="header-tag warning">
          <AlertCircle size={16} />
          <span>Requer atenção</span>
        </div>
      </div>

      {alerts.lowStock.length > 0 && (
        <div className="alerts-section">
          <div className="section-header">
            <h3>ESTOQUE BAIXO</h3>
            <span className="alert-count">{alerts.lowStock.length}</span>
          </div>

          <div className="alerts-list-container">
            <div className="alerts-list">
              {alerts.lowStock.slice(0, 3).map((alert, index) => (
                <div className="alert-item low-stock" key={`low-${index}`}>
                  <AlertCircle className="alert-item-icon" />
                  <div className="alert-content">
                    <p className="alert-title">
                      Stock crítico: {alert.produto.nome} abaixo do mínimo (
                      {alert.atual}/{alert.ideal})
                    </p>
                    <p className="alert-suggestion">
                      Realize uma compra o mais rápido possível
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {alerts.expiringSoon.length > 0 && (
        <div className="alerts-section">
          <div className="section-header">
            <h3>PRODUTOS A EXPIRAR</h3>
            <span className="alert-count">{alerts.expiringSoon.length}</span>
          </div>

          <div className="alerts-list-container">
            <div className="alerts-list">
              {alerts.expiringSoon.slice(0, 3).map((alert, index) => (
                <div className="alert-item expiring" key={`exp-${index}`}>
                  <AlertCircle className="alert-item-icon" />
                  <div className="alert-content">
                    <p className="alert-title">
                      Lote a expirar: {alert.produto.nome}, Lote: {alert.lote}
                    </p>
                    <p className="alert-suggestion">
                      Expira em {alert.diasRestantes} dias (
                      {new Date(alert.validade).toLocaleDateString()})
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Esgotados e vencidos vinham na mesma resposta e eram deitados fora
          aqui: o cartão só pintava o stock baixo e o "a expirar". Um armazém
          com tudo a zero, ou com lotes fora da validade, dizia "0 alertas" —
          e são precisamente os dois casos que não dão para adiar. */}
      {alerts.outOfStock.length > 0 && (
        <div className="alerts-section">
          <div className="section-header">
            <h3>ESGOTADOS</h3>
            <span className="alert-count">{alerts.outOfStock.length}</span>
          </div>

          <div className="alerts-list-container">
            <div className="alerts-list">
              {alerts.outOfStock.slice(0, 3).map((alert, index) => (
                <div className="alert-item out-of-stock" key={`out-${index}`}>
                  <AlertCircle className="alert-item-icon" />
                  <div className="alert-content">
                    <p className="alert-title">
                      Esgotado: {alert.produto.nome}
                    </p>
                    <p className="alert-suggestion">
                      Não há unidades. O ideal são {alert.ideal}.
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {alerts.expired.length > 0 && (
        <div className="alerts-section">
          <div className="section-header">
            <h3>VALIDADE ULTRAPASSADA</h3>
            <span className="alert-count">{alerts.expired.length}</span>
          </div>

          <div className="alerts-list-container">
            <div className="alerts-list">
              {alerts.expired.slice(0, 3).map((alert, index) => (
                <div className="alert-item expired" key={`vencido-${index}`}>
                  <AlertCircle className="alert-item-icon" />
                  <div className="alert-content">
                    <p className="alert-title">
                      Vencido: {alert.produto.nome}, Lote: {alert.lote}
                    </p>
                    <p className="alert-suggestion">
                      Expirou a {new Date(alert.validade).toLocaleDateString()} —{" "}
                      {alert.quantidade} por descartar
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StockAlerts;
